module.exports = __webpack_public_path__ + "img/img_hero_image.fd54feaa.png";